(function () {
  function initCreatorsRail(wrap) {
    const rail = wrap.querySelector('[data-wl-creators]');
    const track = rail && rail.querySelector('.wl-creators__track');
    const prevButton = wrap.querySelector('[data-wl-creators-prev]');
    const nextButton = wrap.querySelector('[data-wl-creators-next]');
    if (!rail || !track || !prevButton || !nextButton) return;

    function step() {
      const card = track.querySelector('.wl-creators__card');
      if (!card) return rail.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      const isOverflowing = track.scrollWidth > rail.clientWidth + 1;
      prevButton.hidden = !isOverflowing;
      nextButton.hidden = !isOverflowing;
      if (!isOverflowing) return;

      const maxScroll = track.scrollWidth - rail.clientWidth;
      prevButton.disabled = rail.scrollLeft <= 1;
      nextButton.disabled = rail.scrollLeft >= maxScroll - 1;
    }

    prevButton.addEventListener('click', () => {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });

    let ticking = false;
    rail.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          updateArrows();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateArrows);
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateArrows).observe(track);
    }

    updateArrows();
  }

  document.querySelectorAll('.wl-creators__rail-wrap').forEach(initCreatorsRail);
})();
